import React from 'react';
import PropTypes from 'prop-types';

const ArticleSearchResultsNonFound = () =>
<div>
    No Articles Found
</div>;

ArticleSearchResultsNonFound.propType = {};

export default ArticleSearchResultsNonFound;


// WEBPACK FOOTER //
// ./src/Components/search/Features/Articles/ArticleSearchResultsNonFound.jsx